<ng-container *ngIf="customerTicket">
  <div class="ticket-transfer-status">
    <div class="ticket-game-info">
      <div
        class="ticket-game-info-title"
        [ngClass]="{
          'flex-column': displayVertical,
        }"
      >
        {{ customerTicket.TeamNames?.HomeTeamName }} <span class="vs-label">VS</span> {{ customerTicket.TeamNames?.AwayTeamName }}
      </div>
      <div class="ticket-game-info-date">
        {{ customerTicket.Date | date: 'd MMM y HH:mm' }}
      </div>
    </div>
    <div
      class="transfer-status"
      [ngClass]="{
        closed: status === ticketStatus.CLOSED,
        open: status === ticketStatus.OPEN,
        'not-open': status === ticketStatus.NOT_OPEN,
        'no-transfers': status === ticketStatus.NO_AVAILABLE_TRANSFERS,
      }"
      *ngIf="showStatus"
    >
      @switch (status) {
        @case (ticketStatus.CLOSED) {
          <div class="transfer-status-label">{{ 'fgbcl.ticket.transfer.status.closed.label' | translate }}</div>
          <div class="transfer-status-name">{{ 'fgbcl.ticket.transfer.status.closed.status' | translate }}</div>
        }
        @case (ticketStatus.NOT_OPEN) {
          <div class="transfer-status-label">{{ 'fgbcl.ticket.transfer.status.not.open.label' | translate }}</div>
          <div class="transfer-status-name">{{ 'fgbcl.ticket.transfer.status.not.open.status' | translate }}</div>
        }
        @case (ticketStatus.NO_AVAILABLE_TRANSFERS) {
          <div class="transfer-status-label">{{ 'fgbcl.ticket.transfer.status.not.available.label' | translate }}</div>
          <div class="transfer-status-name">{{ 'fgbcl.ticket.transfer.status.not.available.status' | translate }}</div>
        }
        @default {
          <div class="transfer-status-label">{{ 'fgbcl.ticket.transfer.status.open.label' | translate }}</div>
          <fgbcl-countdown-v2 [endDateTime]="ticket?.EndTime" (complete)="onRefresh.emit()"></fgbcl-countdown-v2>
        }
      }
    </div>
  </div>
</ng-container>
